import { put } from 'redux-saga/effects';

import { SessionUserSelectors } from '~selectors/SessionInfoSelectors';
import { getAppStore } from '~src/app/AppStore';
import { ContentSpaceInfo,EnterContentSpaceAction, enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { NavLocationAreas } from '~src/spacesPlatform/components/layout/NavLocation';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';
import { LocationTypes } from '~src/ts/models/ILocationInfo';


export function* handleEnterContentSpace(action: EnterContentSpaceAction) {
  if (action.contentSpaceInfo) {
    const contentSpaceInfo: ContentSpaceInfo = action.contentSpaceInfo;
    const defaultSpaceInfo: SpaceInfo = {
      item: contentSpaceInfo.item,
      spaceType: contentSpaceInfo.spaceType,
      subspaceName: contentSpaceInfo.subspaceName
    };

    if (contentSpaceInfo.contentLocation === LocationTypes.PersonalSpace && SessionUserSelectors.sessionUserId(getAppStore().getState()) === contentSpaceInfo.ownerId) {
      const spaceInfoForPersonalSpace: SpaceInfo = {
        item: contentSpaceInfo.item,
        spaceType: contentSpaceInfo.spaceType,
        subspaceName: contentSpaceInfo.subspaceName,
        navLocationOverride: NavLocationAreas.SiteContent.personal_space
      };
      yield put(enterSpace(spaceInfoForPersonalSpace));
    } else {
      yield put(enterSpace(defaultSpaceInfo));
    }
  }
  }
